<template>
  <scroll-bar>
    <div style="height: 70px;align-items: center;display:flex">
      <img :src="pngImg" style="width: 50px;margin-left: 50px;">
      <span style="color: white;font-size: 20px;font-weight: bold;margin-top: 6px;">&nbsp;星报告</span>
    </div>
    <el-menu @select="handleSelect" :default-active="activeTab" mode="vertical" :show-timeout="200"
      :collapse="isCollapse" background-color="#21252b" text-color="#bfcbd9" active-text-color="red">
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
  import {
    mapState,
    mapMutations
  } from 'vuex'
  import {
    mapGetters
  } from 'vuex'
  import SidebarItem from './SidebarItem'
  import ScrollBar from '@/components/ScrollBar'
  import pngImg from '@/assets/images/xbg.png';
  import {
    asyncRouterMap
  } from '@/router/index';

  export default {
    name: 'Sidebar',
    components: {
      SidebarItem,
      ScrollBar
    },
    data() {
      return {
        pngImg
      }
    },
    computed: {
      ...mapState(['activeTab']),
      ...mapGetters([
        'sidebar',
        'routers'
      ]),
      routes() {
        // return this.$router.options.routes
        return this.routers
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    },
    methods: {
      ...mapMutations(['addTab']),
      handleSelect(key) {
        // 当点击菜单项时，添加对应的标签页
        // console.log(key);
        // console.log(this.$router.options.routes);
        // console.log(asyncRouterMap.find(route => key.startsWith(route.path)).children.find(route => key.endsWith(route.path)).meta.title);
        if (key === '/home') {
          this.addTab({
            path: key,
            name: '首页'
          });
        } else {
          this.addTab({
            path: key,
            name: asyncRouterMap.find(route => key.startsWith(route.path)).children.find(route => key.endsWith(route
              .path)).meta.title,
            closable: true
          });
        }
        this.$router.push(key);
      },
      addTabByUrl() {
        const currentPath = this.$route.path;
        if (currentPath === '/home') {
          this.addTab({
            path: currentPath,
            name: '首页'
          });
        } else {
          this.addTab({
            path: currentPath,
            name: asyncRouterMap.find(route => currentPath.startsWith(route.path)).children.find(route =>
              currentPath.endsWith(route
                .path)).meta.title,
            closable: true
          });
        }
      }
    },
    mounted() {
      // 页面挂载时根据 URL 添加对应的标签页
      this.addTabByUrl();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue